<div class="notification-stack" [class]="'notification-position-' + position">
  <app-notification
    *ngFor="let notification of activeNotifications; let i = index"
    [message]="notification.message"
    [type]="notification.type"
    [duration]="notification.duration ?? 3000"
    [position]="'top'" 
    [style.top.px]="getNotificationPosition(i)"
    (closed)="removeNotification(i)">
  </app-notification>
</div>